/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function ProgressBarReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeProgressBarAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const ProgressBarReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {
      count: 0

    },
     action: actionsTypesFromStore.TypeProgressBarAction) => {
      switch (action.type) {
        case actions.ProgressBarActionTypes.PROGRESSBAR_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.ProgressBarActionTypes.PROGRESSBAR_SUCCESS:

          return {
            count: state.count + 1
          }

          break;

        case actions.ProgressBarActionTypes.PROGRESSBAR_RESET:

          return {
            count: 0
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/progressbar/index.ts